
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wishlist",
      function () {
        return require("private-next-pages/wishlist/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wishlist"])
      });
    }
  